import React from 'react';
import clsx from 'clsx';
import PageHeader from 'components/common/general/layouts/PageHeader';
import { createStyles } from '../../globalStyles';
import EmailsDashboard from '../../components/emails-dashboard/index';

const EmailsDashboardPage = (): JSX.Element => {
  const classes = createStyles();

  return (
    <div className={clsx(classes.pageWrapper, classes.widePageWrapper)}>
      <PageHeader
        title="InsuranceMenu Messenger Dashboard"
        subtitle="eFulfillment and Notifications tracking/monitoring utility"
      />
      <EmailsDashboard />
    </div>
  );
};

export default EmailsDashboardPage;
